// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetAppSystemsRequestModel from '../../model/get-app-systems-request-model';
import GetAppSystemsRequestDTO from '../dto/get-app-systems-request-dto';
import dtoSchema from '../schemas/get-app-systems-request-schema';

export default abstract class GetAppSystemsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetAppSystemsRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.isActive = data.isActive;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  */
  isActive?: boolean;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetAppSystemsRequestDTO>): GetAppSystemsRequestModel;
  static toModel(dto: DeepPartial<GetAppSystemsRequestDTO> | undefined | null): GetAppSystemsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetAppSystemsRequestDTO> | undefined | null): GetAppSystemsRequestModel | undefined {
    return dto ? new GetAppSystemsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetAppSystemsRequestModel> | GetAppSystemsRequestModel): GetAppSystemsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      isActive: unwrapped.isActive,
      searchCriteria: unwrapped.searchCriteria,
    } as GetAppSystemsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetAppSystemsRequestModel, can not map to GetAppSystemsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
